import { FilterValues, OptionsSlice } from './store/types'

export type VisibilityParams = FilterValues & OptionsSlice['options']

/**
 * Видимость фильтров в зависимости от значений других фильтров или внешних параметров.
 * Чтобы правило зависело от видимости другого фильтра — вынесите его предикат
 * в именованную функцию (как isSaleTypesVisible) и переиспользуйте её.
 */
const isSaleTypesVisible = ({ orgIds, orgs }: VisibilityParams) => orgs.length > 1 && orgIds?.length !== 1

const isCustomerTypesVisible = ({ orgIds }: VisibilityParams) => orgIds?.length === 1

const visibilityRules = {
  orgTypes: (_: VisibilityParams) => true,
  orgs: (_: VisibilityParams) => true,
  buildings: ({ orgIds }: VisibilityParams) => orgIds?.length === 1,
  schoolYears: ({ orgIds }: VisibilityParams) => orgIds?.length === 1,
  period: (_: VisibilityParams) => true,
  saleTypes: isSaleTypesVisible,
  foodModes: (params: VisibilityParams) =>
    isSaleTypesVisible(params) && params.saleTypeIds?.length === 1 && params.saleTypeIds[0] === 'complex',
  customerTypes: isCustomerTypesVisible,
  salePoints: ({ orgIds }: VisibilityParams) => orgIds?.length === 1,
  employees: (params: VisibilityParams) =>
    isCustomerTypesVisible(params) && params.customerTypeIds?.length === 1 && params.customerTypeIds[0] === 'employee',
  mail: (_: VisibilityParams) => true,
  // ADD NEW HERE
}

export type Visibility = Record<keyof typeof visibilityRules, boolean>

function typedKeys<T extends object>(obj: T) {
  return Object.keys(obj) as Array<keyof T>
}

export function calculateVisibility(context: VisibilityParams) {
  const result = {} as Visibility
  for (const key of typedKeys(visibilityRules)) {
    result[key] = visibilityRules[key](context)
  }
  return result
}
